import { render, staticRenderFns } from "./ListLegendFilter.vue?vue&type=template&id=72bc953e&scoped=true&"
import script from "./ListLegendFilter.vue?vue&type=script&lang=js&"
export * from "./ListLegendFilter.vue?vue&type=script&lang=js&"
import style0 from "./ListLegendFilter.vue?vue&type=style&index=0&id=72bc953e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc953e",
  null
  
)

export default component.exports